// extracted by mini-css-extract-plugin
export var contentBody = "_64-9";
export var headerImage = "_64-2";
export var imageButton = "_64-7";
export var imageButtonIcon = "_64-8";
export var imageHeader = "_64-4";
export var imageHeaderText = "_64-5";
export var imageOverlay = "_64-3";
export var imageTitle = "_64-6";
export var imageWrapper = "_64-1";
export var taskList = "_64-a";
export var widget = "_64-0";